import { MmTaskType } from '../types/enums';

export const MM_ZONING_MODELS_REGISTRY = false;

/** Скрывает только выбор типа KVI при создании задания: бэкенд под этот тип не готов */
export const MM_KVI_SELECTABLE = false;

export function isTaskTypeSelectable(type: MmTaskType): boolean {
  if (type === MmTaskType.KVI) {
    return MM_KVI_SELECTABLE;
  }

  return true;
}

export function taskTypeDisabledReasonKey(type: MmTaskType): string | null {
  if (type === MmTaskType.KVI && !MM_KVI_SELECTABLE) {
    return 'priceMonitoring.mobileMonitoring.taskTypes.kviDisabledHint';
  }

  return null;
}

export const MM_IMPORT_TWO_STEP_CONFIRM = true;

export const MM_SHOW_COMPETITOR_PRIORITY = false;

export const MM_IMPORT_MAX_FILE_BYTES = 10 * 1024 * 1024;

export const MM_IMPORT_ALLOWED_EXTENSIONS = ['.xlsx', '.xls'];

export const MM_AUDITOR_NAME_PARTS_IN_PAYLOAD = true;

export const MM_AUDITOR_CONTACTS_IN_PAYLOAD = true;

export interface MmTaskListCapabilities {
  statusFilter: boolean;
  typeFilter: boolean;
  competitorSearch: boolean;
  zoneFilter: boolean;
  auditorFilter: boolean;
  createdPeriodFilter: boolean;
  statusSort: boolean;
  typeSort: boolean;
  competitorSort: boolean;
  createdAtSort: boolean;
}

/** Флаги идут в паре с MM_TASKS_IGNORED_FILTER_KEYS: иначе контрол активен, а фильтр не работает */
export const MM_TASK_LIST_CAPABILITIES: MmTaskListCapabilities = {
  statusFilter: true,
  typeFilter: true,
  competitorSearch: true,
  zoneFilter: true,
  auditorFilter: true,
  createdPeriodFilter: true,
  statusSort: true,
  typeSort: true,
  competitorSort: true,
  createdAtSort: true,
};
